// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import { RobotIcon } from "src/assets/icons";

// Styles
import { getSurfaceTokens } from "src/styles/mui/muiStylesHelper";

type BotMessageType = {
  chatMessage: string;
};

const BotMessage = ({ chatMessage }: BotMessageType) => {
  const theme = useTheme();
  const { surfaceHover } = getSurfaceTokens(theme);

  return (
    <Grid sx={{ display: "flex", alignItems: "flex-end", gap: "8px" }}>
      <Box
        sx={{
          backgroundColor: "#202338",
          borderRadius: "50%",
          color: "#FFF",
          height: "fit-content",
          width: "fit-content",
          padding: "8px",
        }}
      >
        <RobotIcon />
      </Box>
      <Box
        sx={{
          backgroundColor: surfaceHover,
          borderRadius: "8px 8px 8px 0px",
          padding: "12px",
          width: "fit-content",
        }}
      >
        {chatMessage}
      </Box>
    </Grid>
  );
};

export default BotMessage;
